import { render, staticRenderFns } from "./SingleCarView.vue?vue&type=template&id=2d27fa3e&"
import script from "./SingleCarView.vue?vue&type=script&lang=js&"
export * from "./SingleCarView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports